import type { LocationGroup } from '@/types';

export const LOCATION_COLORS: Record<LocationGroup, string> = {
  city: '#fbbf24',
  village: '#a3e635',
  forest: '#22c55e',
  dungeon: '#a855f7',
  outdoors: '#38bdf8',
  indoors: '#94a3b8',
  wonders: '#f472b6',
  naval: '#06b6d4',
};

export function groupColor(group: string): string {
  return LOCATION_COLORS[group as LocationGroup] ?? '#94a3b8';
}
